// Makes highlight effect in search process
function highlightSearch() {
    const addClass = (selector, className) => {
        const element = document.querySelector(selector);
        if (element) {
            element.classList.add(className);
        }
    };

    addClass(".search__icon", "highlight");
    addClass(".search-items", "highlight");
    addClass(".search-button", "but--c2a");
    addClass(".search-input", "search-input--c2a");
}